import builder from '../builder';
import PinLocation1 from '../../streamline-icons/bold/pin-location-1.svg';

export default builder('IconPinLocation1Bold', PinLocation1);
